module.exports = __webpack_public_path__ + "static/media/Poppins-Medium-500.06582556.ttf";